import React from 'react';

import classes from './TopNote.module.css';


import 'bootstrap/dist/css/bootstrap.min.css';
import Spinner from 'react-bootstrap/Spinner';

function TopNote(props){
    return(
        <div className={classes.box}>
            <hr className={classes.smallhr}></hr>
            <h6>Top Notes: {props.product.data.topNote}</h6>
            <hr className={classes.smallhr}></hr>
            <h6>Middle Notes: {props.product.data.middleNote}</h6>
            <hr className={classes.smallhr}></hr>
            <h6>Base Notes: {props.product.data.baseNote}</h6>
            <hr className={classes.smallhr}></hr>
            
           
         
      
       
         
      </div>
    )
}


export default TopNote;   